module.exports = __webpack_public_path__ + "static/media/spinner.2fa4ca03.gif";